import type { CreateUploadRequestsInput, CreateUploadRequestsResult } from '@peles/shared';
import { apiClient } from './client';

/**
 * `POST /upload-requests` — ask people for files about a record. One
 * single-use link per address, emailed to it; every link comes back too, so
 * the producer can copy one where the email did not reach.
 */
export async function createUploadRequests(
  input: CreateUploadRequestsInput,
): Promise<CreateUploadRequestsResult> {
  const { data } = await apiClient.post<CreateUploadRequestsResult>('/upload-requests', input);
  return data;
}
